export default __webpack_public_path__ + "static/media/yvonne_heimann.b10cef65.png";